console.log("Assistant Subtypes Loaded");

const CCTV_SUBTYPES = {

    OUTDOOR: [
        "outdoor",
        "bullet",
        "4g",
        "ptz",
        "floodlight"
    ],

    INDOOR: [
        "indoor",
        "pan/tilt",
        "pan tilt",
        "wifi indoor"
    ],

    BULB: [
        "bulb"
    ],

    BABY_MONITOR: [
        "baby monitor"
    ],

    DASH_CAMERA: [
        "dash"
    ],

    DVR: [
        "dvr"
    ]

};

function detectCCTVSubtype(product){

    const text=(

        product.title+" "+

        (product.product_type||"")+" "+

        (Array.isArray(product.tags)

            ? product.tags.join(" ")

            : product.tags||"")

    ).toLowerCase();

    for(const subtype in CCTV_SUBTYPES){

        const words=CCTV_SUBTYPES[subtype];

        if(words.some(word=>text.includes(word))){

            return subtype;

        }

    }

    return "UNKNOWN";

}